import styled from 'styled-components'
import { Alert } from 'shards-react'

export const FormAuthContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 65vh;
    font-family: Roboto, Helvetica, Arial, sans - serif;
    @media (min-width: 1100px) {
        height: 74vh;
    }
`

export const CustomizedAlert = styled(Alert)`
    font-weight: 500;
    @media (min-width: 1100px) {
        font-size: 1.2em;
        letter-spacing: 1px;
        font-weight: 600;
    }
`
